{
  "version": 1,
  "asset_id": "1620cded-2ba3-406d-82e5-2059a72413e8",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/1620cded-2ba3-406d-82e5-2059a72413e8/svc-link-building-1200.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/1620cded-2ba3-406d-82e5-2059a72413e8/svc-link-building-1200.webp",
  "original_filename": "svc-link-building-1200.webp",
  "size": 16544,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:26:50Z"
}
